module.exports = __webpack_public_path__ + "static/media/strawberry.d8c91125.svg";